import Api from '@/common/api.helper'

export default {
  state: {
    empreendimentos: [],
    empreendimentosDestaques: [],
    empreendimentosFiltros: [],
    empreendimentosCategorias: [],
    actualEmpreendimento: null,
    empreendimentoAndares: [],
    empreendimentoGalerias: [],
    empreendimentoApartamentos: [],
    empreendimentoEstagios: [],
    empreendimentoDates: [],
    empreendimentoEstagioGaleria: [],
    empreendimentoEnderecos: []
  },
  actions: {
    loadEmpreendimentos ({ commit }, params) {
      return Api.get('/businesses/businesses/all?page=' + params.page + '&filter=' + params.filter + '&category=' + params.category + '&delivered=' + params.delivered + '&notPaginate=' + params.notPaginate + '&for_sale=' + params.for_sale).then(response => {
        commit('setEmpreendimentos', response.data)
        return response
      })
    },
    loadEmpreendimentosDestaques ({ commit }) {
      return Api.get('/businesses/businesses/featured').then(response => {
        commit('setEmpreendimentosDestaques', response.data)
        return response
      })
    },
    loadEmpreendimentosFiltros ({ commit }) {
      return Api.get('/businesses/filters/all').then(response => {
        commit('setEmpreendimentosFiltros', response.data)
        return response
      })
    },
    loadEmpreendimentosCategorias ({ commit }) {
      return Api.get('/businesses/categories/all').then(response => {
        commit('setEmpreendimentosCategorias', response.data)
        return response
      })
    },
    showEmpreendimento ({ commit }, empreendimentoSlug) {
      return Api.get(`/businesses/businesses/details/${empreendimentoSlug}`).then(response => {
        commit('setActualEmpreendimento', response.data)
        return response
      })
    },
    showEmpreendimentoAndares ({ commit }, empreendimentoSlug) {
      return Api.get(`/businesses/businesses/${empreendimentoSlug}/floors/all`).then(response => {
        commit('setEmpreendimentoAndares', response.data)
        return response
      })
    },
    showEmpreendimentoGaleria ({ commit }, empreendimentoSlug) {
      return Api.get(`/businesses/businesses/${empreendimentoSlug}/galeries/all`).then(response => {
        commit('setEmpreendimentoGalerias', response.data)
        return response
      })
    },
    showEmpreendimentoApartamentos ({ commit }, empreendimentoSlug) {
      return Api.get(`/businesses/businesses/${empreendimentoSlug}/apartments/all`).then(response => {
        commit('setEmpreendimentoApartamentos', response.data)
        return response
      })
    },
    showEmpreendimentoEstagios ({ commit }, empreendimentoSlug) {
      return Api.get(`/businesses/businesses/${empreendimentoSlug}/stages/all`).then(response => {
        commit('setEmpreendimentoEstagios', response.data)
        return response
      })
    },
    showEmpreendimentoEstagiosDates ({ commit }, empreendimentoSlug) {
      return Api.get(`/businesses/businesses/${empreendimentoSlug}/stagegalleries/dates`).then(response => {
        commit('setEmpreendimentoDates', response.data)
        return response
      })
    },
    showEmpreendimentoEstagiosGaleria ({ commit }, empreendimentoSlug) {
      return Api.get(`/businesses/businesses/${empreendimentoSlug}/stagegalleries/all`).then(response => {
        commit('setEmpreendimentoEstagioGaleria', response.data)
        return response
      })
    },
    LoadEmpreendimentoEnderecos ({ commit }) {
      return Api.get(`/businesses/businesses/addresses`).then(response => {
        commit('setEmpreendimentoEnderecos', response.data)
        return response
      })
    }
  },
  mutations: {
    setEmpreendimentos (state, empreendimentos) {
      state.empreendimentos = empreendimentos
    },
    setEmpreendimentosDestaques (state, empreendimentosDestaques) {
      state.empreendimentosDestaques = empreendimentosDestaques
    },
    setEmpreendimentosFiltros (state, empreendimentosFiltros) {
      state.empreendimentosFiltros = empreendimentosFiltros
    },
    setEmpreendimentosCategorias (state, empreendimentosCategorias) {
      state.empreendimentosCategorias = empreendimentosCategorias
    },
    setActualEmpreendimento (state, actualEmpreendimento) {
      state.actualEmpreendimento = actualEmpreendimento
    },
    setEmpreendimentoAndares (state, empreendimentoAndares) {
      state.empreendimentoAndares = empreendimentoAndares
    },
    setEmpreendimentoGalerias (state, empreendimentoGalerias) {
      state.empreendimentoGalerias = empreendimentoGalerias
    },
    setEmpreendimentoApartamentos (state, empreendimentoApartamentos) {
      state.empreendimentoApartamentos = empreendimentoApartamentos
    },
    setEmpreendimentoEstagios (state, empreendimentoEstagios) {
      state.empreendimentoEstagios = empreendimentoEstagios
    },
    setEmpreendimentoDates (state, empreendimentoDates) {
      state.empreendimentoDates = empreendimentoDates
    },
    setEmpreendimentoEstagioGaleria (state, empreendimentoEstagioGaleria) {
      state.empreendimentoEstagioGaleria = empreendimentoEstagioGaleria
    },
    setEmpreendimentoEnderecos (state, empreendimentoEnderecos) {
      state.empreendimentoEnderecos = empreendimentoEnderecos
    }
  },
  getters: {
    empreendimentos (state) {
      return state.empreendimentos
    },
    empreendimentosDestaques (state) {
      return state.empreendimentosDestaques
    },
    empreendimentosFiltros (state) {
      return state.empreendimentosFiltros
    },
    empreendimentosCategorias (state) {
      return state.empreendimentosCategorias
    },
    actualEmpreendimento (state) {
      return state.actualEmpreendimento
    },
    empreendimentoAndares (state) {
      return state.empreendimentoAndares
    },
    empreendimentoGalerias (state) {
      return state.empreendimentoGalerias
    },
    empreendimentoApartamentos (state) {
      return state.empreendimentoApartamentos
    },
    empreendimentoEstagios (state) {
      return state.empreendimentoEstagios
    },
    empreendimentoDates (state) {
      return state.empreendimentoDates
    },
    empreendimentoEstagioGaleria (state) {
      return state.empreendimentoEstagioGaleria
    },
    empreendimentoEnderecos (state) {
      return state.empreendimentoEnderecos
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/empreendimentos.js